import { cn } from "@aircall/ds";
import { AnchorHTMLAttributes } from "react";

type LinkProps = AnchorHTMLAttributes<HTMLAnchorElement>;

export function Link({ className, children, ...rest }: LinkProps) {
  return (
    <a
      className={cn("cursor-pointer text-primary hover:underline", className)}
      {...rest}
    >
      {children}
    </a>
  );
}
